import point from "../point";
import line from "../line";
import config from "../../../store/sqftConfig";

const horseshoe = function() {
  let points;
  if(config.measureUnit === "Metric" ) {
    points = [
      new point(0, -20, "lefttop"),
      new point(181, -20, "righttop"),
      new point(181, 80, "rightbottom"),
      new point(157.38, 80, "leftbottom"),
      new point(157.38, 3.62, "leftbottom", true),
      new point(23.62, 3.62, "rightbottom", true),
      new point(23.62, 80, "rightbottom"),
      new point(0, 80, "leftbottom")
    ];
  } else {
    points = [
      new point(0, -20, "lefttop"),
      new point(181, -20, "righttop"),
      new point(181, 80, "rightbottom"),
      new point(155, 80, "leftbottom"),
      new point(155, 6, "leftbottom", true),
      new point(26, 6, "rightbottom", true),
      new point(26, 80, "rightbottom"),
      new point(0, 80, "leftbottom")
    ];
  }

  let lines = [
    new line(points[0], points[1]),
    new line(points[1], points[2]),
    new line(points[2], points[3]),
    new line(points[3], points[4]),
    new line(points[4], points[5]),
    new line(points[5], points[6]),
    new line(points[6], points[7]),
    new line(points[7], points[0])
  ];

  return lines;
};

export default horseshoe
